import type { BuyerProductGetResponseType } from "@sellar-io/api-v2/types";

export const useProductAvailableFormats = (
  product: Pick<BuyerProductGetResponseType, "Products"> | undefined,
  selectedProductId: number | undefined,
) =>
  product?.Products.filter((item) => item.id !== selectedProductId)
    .map((item) => item.name?.split(" • ")[1])
    .filter(Boolean) ?? [];
